import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faPhone,
  faEnvelope,
  faAddressCard,
  faPlus,
  faEdit,
  faTrash,
  faUserGroup,
  faCity,
  faSignsPost,
  faMap,
  faGlobe,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import "./classes/ManageCustomer.css";
import "./classes/Main.css";
import { useAuth } from "../AuthContext";
import Pagination from "./Pagination";

const API_BASE = configData.APP_URL;

const ManageCustomer = () => {
  // const customers = [
  //   {id:1,name:"test_user",phone:"123",email:"test@gmail.com",address:"test"},
  //   {id:2,name:"test_user1",phone:"1234",email:"test1@gmail.com",address:"test1"},
  // ];
  const [customers, setCustomers] = useState([]);
  const [modal, setModal] = useState(false);

  const [editFormData, setEditFormData] = useState({
    // name: "",
    first_name:"",
    last_name:"",
    phone: "",
    gst_number:"",
    email: "",
    address: "",
    city:"",
    state:"",
    country:"",
    postal_code:""
  });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submittingEdit, setSubmittingEdit] = useState(false);

  const [formData, setFormData] = useState({
    // name: "",
    first_name:"",
    last_name:"",
    phone: "",
    gst_number:"",
    email: "",
    address: "",
    city:"",
    state:"",
    country:"",
    postal_code:""
  });

  const { user } = useAuth();
  // const companyId = user?.company_id;

  // if (!companyId) {
  //   alert("No company is selected");
  //   return;
  // }

    const [currentPage, setCurrentPage] = useState(1);
    const customersPerPage = 15;

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0,0);
    };

    const indexOfLastItem = currentPage * customersPerPage;
    const indexOfFirstItem = indexOfLastItem - customersPerPage;
    const currentItems = customers.slice(indexOfFirstItem, indexOfLastItem);

  const [editingId, setEditingId] = useState(null);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}customerapi/list`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setCustomers(data);
      } else if (data?.data && Array.isArray(data.data)) {
        setCustomers(data.data);
      } else if (data?.customers && Array.isArray(data.customers)) {
        setCustomers(data.customers);
      } else {
        setCustomers([]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidPhone = (phone) => {
    return /^(\+91[\-\s]?)?[0]?[6-9]\d{9}$/.test(phone);
  };
  
    const isValidGST = (gst) => {
        if (!gst) return false; 

        gst = gst.trim().toUpperCase(); 

        // Regex for GSTIN
        const gstRegex = /^[0-3][0-9][A-Z0-9]{13}$/;
        return gstRegex.test(gst);
    };


  const handleCustomerCreate = async (e) => {
    e.preventDefault();

    if (!formData.first_name.trim()) {
      alert("First name is required");
      return;
    }
    if (!formData.last_name.trim()) {
      alert("Last name is required");
      return;
    }

    if (formData.phone.trim() && !isValidPhone(formData.phone.trim())) {
      alert("Please enter a valid phone number");
      return;
    }
     const gst = formData.gst_number?.trim();

           if (gst && !isValidGST(gst)) {
      alert("Please enter a valid GST Number");
      return;
    }



    setSubmitting(true);
    try {
        const res = await fetch(`${API_BASE}customerapi/create`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to create customer");
        alert("Customer created successfully");
      setFormData({
        first_name: "",
        last_name: "",
        phone: "",
        gst_number:"",
        email: "",
        address: "",
        city:"",
        state:"",
        country:"",
        postal_code:""
      });
      fetchCustomers();
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
    } finally {
      setSubmitting(false);
    }
  };

const handleEdit = (customer) => {
  const id = customer.id ?? customer.customer_id;

  setEditFormData({
    first_name: customer.first_name ?? "",
    last_name: customer.last_name ?? "",
    phone: customer.phone ?? customer.phone_number ?? "",
    gst_number:customer.gst_number ?? "",
    email: customer.email ?? "",
    address: customer.address ?? "",
    city: customer.city ?? "",
    state: customer.state ?? "",
    country: customer.country ?? "",
    postal_code: customer.postal_code ?? "",
  });

  setEditingId(id);
  setModal(true);
};
const handleEditSubmit = async (e) => {
  e.preventDefault();

  if (!editFormData.first_name.trim()) {
    alert("First name is required");
    return;
  }
   if (!editFormData.last_name.trim()) {
    alert("Last name is required");
    return;
  }

  if (editFormData.phone.trim() && !isValidPhone(editFormData.phone.trim())) {
    alert("Please enter a valid phone number");
    return;
  }
    if (editFormData.gst_number.trim() && !isValidGST(editFormData.gst_number.trim())) {
    alert("Please enter a valid Gst number");
    return;
  }

  setSubmittingEdit(true);
  try {
    const res = await fetch(`${API_BASE}customerapi/update?customer_id=${editingId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editFormData),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to update customer");

    alert("Customer updated successfully");

    setModal(false);
    setEditingId(null);
    setEditFormData({ first_name: "",last_name:"", phone: "",gst_number:"", email: "", address: "",city:"",state:"",country:"",postal_code:"" });
    fetchCustomers();
  } catch (error) {
    alert(error.message);
  } finally {
    setSubmittingEdit(false);
  }
};
const handleCancelEdit = () => {
  setModal(false);
  setEditingId(null);
  setEditFormData({ name: "", phone: "",gst_number:"", email: "", address: "" ,city:"",state:"",country:"",postal_code:"" });
};

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this customer?")) return;
    try {
      const res = await fetch(`${API_BASE}customerapi/delete?customer_id=${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to delete customer");
      alert("Customer deleted successfully");
          setCustomers((prev) =>
      prev.filter(
        (customer) => (customer.id ?? customer.customer_id) !== id
      )
    );
      if (editingId === id) {
        setEditingId(null);
        setFormData({ first_name: "",last_name: "", phone: "",gst_number:"", email: "", address: "",city:"",state:"",country:"",postal_code:""  });
      }
      // fetchCustomers();
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
    }
  };


  return (
    <div className="manage-customer-page">
      <Helmet>
        <title>Manage Customers</title>
      </Helmet>

      <div className="main">
        {/* LEFT */}
        <div className="left-container">
          <span className="create-user-title">
            <FontAwesomeIcon icon={faUser} />
            <h3>Customer Management</h3>
          </span>

          <div className="create-user-container">
            <h2>{editingId ? "Edit Customer" : "Add New Customer"}</h2>

            <form onSubmit={handleCustomerCreate}>
              {/* NAME */}
              <div className="login-form-field">
                <label htmlFor="name">First Name *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <input
                    id="name"
                    type="text"
                    name="first_name"
                    placeholder="First name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="login-form-field">
                <label htmlFor="name">Last Name *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <input
                    id="name"
                    type="text"
                    name="last_name"
                    placeholder="Last name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* PHONE */}
              <div className="login-form-field">
                <label htmlFor="phone">Phone</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/*Gst Number*/}
              <div className="login-form-field">
                  <label htmlFor="gst_number">GST Number</label>
                  <div className="login-input-container">
                      <span className="login-input-icon-container">
                          <FontAwesomeIcon icon={faFileInvoice} />
                      </span>
                      <input
                          type="text"
                          placeholder="GST Number"
                          name="gst_number"
                          value={formData.gst_number}
                          onChange={handleChange}
                      />
                  </div>
              </div>

              {/* EMAIL */}
              <div className="login-form-field">
                <label htmlFor="email">Email</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Email address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* ADDRESS */}
              <div className="login-form-field">
                <label htmlFor="address">Address</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faAddressCard} />
                  </span>
                  <input
                    id="address"
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
              </div>
               <div className="login-form-field">
                <label htmlFor="city">City</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faCity} />
                  </span>
                  <input
                    id="city"
                    type="text"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
              </div>
               <div className="login-form-field">
                <label htmlFor="state">State</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faMap} />
                  </span>
                  <input
                    id="state"
                    type="text"
                    name="state"
                    placeholder="State"
                    value={formData.state}
                    onChange={handleChange}
                  />
                </div>
              </div>
               <div className="login-form-field">
                <label htmlFor="country">Country</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faGlobe} />
                  </span>
                  <input
                    id="country"
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={formData.country}
                    onChange={handleChange}
                  />
                </div>
              </div>
               <div className="login-form-field">
                <label htmlFor="postal_code">Postal Code</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>
                  <input
                    id="postal_code"
                    type="text"
                    name="postal_code"
                    placeholder="Postal Code"
                    value={formData.postal_code}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* SUBMIT */}
              <div className="form-actions">
                <button type="submit" className="login-form-submit" disabled={submitting}>
                  <FontAwesomeIcon icon={faPlus} />
                  {submitting ? " Saving..." : " Add Customer"}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* RIGHT */}
        <div className="center left-center">
        <div className="product-search-container">
          <div className="existing-customers-header">
            <FontAwesomeIcon icon={faUserGroup} />
            <h3>Existing Customers</h3>
          </div>
          {loading ? (
            <p className="no-data-message">Loading customers...</p>
          ) : customers.length === 0 ? (
            <p className="no-data-message">No customers yet. Add one using the form.</p>
          ) : (
          <>
          <div className="customer-table-wrapper customer-table-desktop">
          <table className="existing-users-table customer-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Address</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((customer) => {
                const id = customer.id ?? customer.customer_id;
                const name = customer.name ?? customer.customer_name ?? "—";
                const phone = customer.phone ?? customer.phone_number ?? "—";
                return (
                <tr key={id}>
                  <td>
                  {[customer.first_name, customer.last_name].filter(Boolean).join(" ") || "—"}
                </td>
                  <td>{phone}</td>
                  <td>{customer.email || "—"}</td>
                  <td>{customer.address || "—"}</td>
                  <td className="icon-cell">
                    <span
                      className="action-icon edit"
                      onClick={() => handleEdit(customer)}
                      title="Edit"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </span>
                    <span
                      className="action-icon delete"
                      onClick={() => handleDelete(id)}
                      title="Delete"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  </td>
                </tr>
              );
              })}
            </tbody>
          </table>
          <Pagination
            currentPage={currentPage}
            totalItems={customers.length}
            itemsPerPage={customersPerPage}
            onPageChange={handlePageChange}
          />
          </div>

          <div className="customer-cards-mobile">
            {currentItems.map((customer) => {
              const id = customer.id ?? customer.customer_id;
              const name = customer.name ?? customer.customer_name ?? "—";
              const phone = customer.phone ?? customer.phone_number ?? "—";
              return (
                <div key={id} className="customer-card">
                  <div className="customer-card-main">
                    <span className="customer-card-name">{[customer.first_name, customer.last_name].filter(Boolean).join(" ") || "—"}</span>
                    <span className="customer-card-phone">{phone || "—"}</span>
                  </div>
                  <div className="customer-card-secondary">
                    {customer.email && <span>{customer.email}</span>}
                    {customer.address && <span>{customer.address}</span>}
                  </div>
                  <div className="customer-card-actions">
                    <button type="button" className="action-btn edit" onClick={() => handleEdit(customer)} title="Edit">
                      <FontAwesomeIcon icon={faEdit} /> Edit
                    </button>
                    <button type="button" className="action-btn delete" onClick={() => handleDelete(id)} title="Delete">
                      <FontAwesomeIcon icon={faTrash} /> Delete
                    </button>
                  </div>
                </div>
              );
            })}
            <Pagination
              currentPage={currentPage}
              totalItems={customers.length}
              itemsPerPage={customersPerPage}
              onPageChange={handlePageChange}
            />
          </div>
          </>
          )}
        </div>
        </div>
        {modal && (
          <div className="manage-customer-modal">
  <div className="modal-overlay">
    <div className="modal-content">
      <h2>Edit Customer</h2>

      <form onSubmit={handleEditSubmit}>
        <table>
          <tbody>
            <tr className="login-form-field login-form-field-modal">
              <td><label>First Name *</label></td>
              <td>
                <input
                  type="text"
                  name="first_name"
                  value={editFormData.first_name}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, first_name: e.target.value })
                  }
                />
              </td>
            </tr>
             <tr className="login-form-field login-form-field-modal">
              <td><label>Last Name *</label></td>
              <td>
                <input
                  type="text"
                  name="last_name"
                  value={editFormData.last_name}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, last_name: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr className="login-form-field login-form-field-modal">
              <td><label>Phone</label></td>
              <td>
                <input
                  type="text"
                  name="phone"
                  value={editFormData.phone}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, phone: e.target.value })
                  }
                />
              </td>
            </tr>

                {/*Gst Number*/}
               <tr className="login-form-field login-form-field-modal">
                  <td><label>GST Number</label></td>
                    <td>
                      <input
                          type="text"
                          name="gst_number"
                          value={editFormData.gst_number}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, gst_number: e.target.value })
                            }
                      />
                 </td>
            </tr>

            <tr className="login-form-field login-form-field-modal">
              <td><label>Email</label></td>
              <td>
                <input
                  type="email"
                  name="email"
                  value={editFormData.email}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, email: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr className="login-form-field login-form-field-modal">
              <td><label>Address</label></td>
              <td>
                <input
                  type="text"
                  name="address"
                  value={editFormData.address}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, address: e.target.value })
                  }
                />
              </td>
            </tr>
              <tr className="login-form-field login-form-field-modal">
              <td><label>City</label></td>
              <td>
                <input
                  type="text"
                  name="city"
                  value={editFormData.city}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, city: e.target.value })
                  }
                />
              </td>
            </tr>
              <tr className="login-form-field login-form-field-modal">
              <td><label>State</label></td>
              <td>
                <input
                  type="text"
                  name="state"
                  value={editFormData.state}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, state: e.target.value })
                  }
                />
              </td>
            </tr>
              <tr className="login-form-field login-form-field-modal">
              <td><label>Country</label></td>
              <td>
                <input
                  type="text"
                  name="country"
                  value={editFormData.country}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, country: e.target.value })
                  }
                />
              </td>
            </tr>
              <tr className="login-form-field login-form-field-modal">
              <td><label>Postal Code</label></td>
              <td>
                <input
                  type="text"
                  name="postal_code"
                  value={editFormData.postal_code}
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, postal_code: e.target.value })
                  }
                />
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <div className="modal-buttons">
                  <button type="submit" disabled={submittingEdit}>
                    {submittingEdit ? "Saving..." : "Update"}
                  </button>
                  <button type="button" onClick={handleCancelEdit}>
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
  </div>
)}
      </div>
    </div>
  );
};

export default ManageCustomer;